(function() {
	
	var GeomUtils = {};
	
	if(!Math.DEG_TO_RADS)
		Math.DEG_TO_RADS = Math.PI / 180;
	
	/**
	*	Gets the distance squared between two points, since square roots tend to be slow
	*	and should be avoided if possible.
	*	@param p1 The first point.
	*	@param p2 The second point.
	*	@return The distance between the two points squared.
	*/
	GeomUtils.distanceSq = function(p1X, p1Y, p2X, p2Y)
	{
		if(typeof p1X != "number")
		{
			//shift p2 back
			p2Y = p2X;
			p2X = p1Y;
			
			p1Y = p1X.y;
			p1X = p1X.x;
		}
		if(typeof p2X != "number")
		{
			p2Y = p2X.y;
			p2X = p2X.x;
		}
		return (p1X - p2X) * (p1X - p2X) + (p1Y - p2Y) * (p1Y - p2Y);
	};
	
	/**
	*	Gets the distance between two points.
	*	@param p1 The first point.
	*	@param p2 The second point.
	*	@return The distance between the two points.
	*/
	GeomUtils.distance = function(p1X, p1Y, p2X, p2Y)
	{
		if(typeof p1X != "number")
		{
			//shift p2 back
			p2Y = p2X;
			p2X = p1Y;
			
			p1Y = p1X.y;
			p1X = p1X.x;
		}
		if(typeof p2X != "number")
		{
			p2Y = p2X.y;
			p2X = p2X.x;
		}
		return Math.sqrt((p1X - p2X) * (p1X - p2X) + (p1Y - p2Y) * (p1Y - p2Y));
	};
	
	/**
	*	Gets the squared length of a point. Since square roots are slow, this should improve speed
	*	over regular length.
	*	@param p The point to get the length squared of.
	*	@param The length squared.
	*/
	GeomUtils.getLengthSq = function(p)
	{
		return p.x * p.x + p.y * p.y;
	};
	
	/**
	 * Gets the dot product between two points. The math is p1.x * p2.x + p1.y * p2.y.
	 * @param p1X The x value of the first point.
	 * @param p1Y The y value of the first point.
	 * @param p2X The x value of the second point.
	 * @param p2Y The y value of the second point.
	 * @return The dot product of the two points.
	 */
	GeomUtils.dotProduct = function(p1X, p1Y, p2X, p2Y)
	{
		if(typeof p1X != "number")
		{
			//shift p2 back
			p2Y = p2X;
			p2X = p1Y;
			
			p1Y = p1X.y;
			p1X = p1X.x;
		}
		if(typeof p2X != "number")
		{
			p2Y = p2X.y;
			p2X = p2X.x;
		}
		return p1X * p2X + p1Y * p2Y;
	};
	
	/**
	 * Rotates a point by <code>angle</code> degrees.
	 * @param angle The angle to rotate by in degrees
	 * @param p The point to rotate around 0,0.
	 */
	GeomUtils.rotatePoint = function(angle, p)
	{
		angle *= Math.DEG_TO_RADS;
		var s = Math.sin(angle);
		var c = Math.cos(angle);
		var xnew = p.x * c - p.y * s;
		var ynew = p.x * s + p.y * c;
		p.x = xnew;
		p.y = ynew;
	};
		
	namespace('heist').GeomUtils = GeomUtils;
}());